import React from 'react';
import { AsyncSelect, AsyncSelectImplementationProps } from './async-select';
import { useUserOptionSearch } from '../use-user-option-search';

type UserSelectProps = Omit<AsyncSelectImplementationProps, 'minimumQueryLength'>;

export const UserSelect = React.forwardRef<HTMLDivElement, UserSelectProps>(function UserSelect(
    props: UserSelectProps,
    ref
): React.ReactElement {
    const { searchUserOptions } = useUserOptionSearch();
    return <AsyncSelect {...props} ref={ref} getOptions={searchUserOptions} />;
});
